import React from "react";
import { useUsergroupListQuery } from "../../services/reducers/usergroup/usergroupSlice";

const UserGroupList = () => {

    const { data, error, isLoading } = useUsergroupListQuery('');

    return (
        <>
            {Array.isArray(data?.userGroups) && data?.userGroups.length > 0 ?
                data.userGroups.map((userGroup, index) => (
                    <p key={index}>{userGroup.name}</p>
                )) : null
            }
        </>
    )
}

export default UserGroupList;
